import styled from "styled-components";

export const BadgeButton = styled.button`
  all:unset;
  background-color: #DEECFF;
  padding: 8px;
  border: 1px solid #00357A;
  border-radius: 99px;
  display: flex;
  flex-direction:row;
  align-items: center;
  gap:4px;
  color: #0E0E0E;
  font-size:14px;
  cursor: pointer;
`;
